import { get as lodashGet } from "radash"

import { ACCESS_TOKEN_KEY } from "@be-miniapp/app-configs"
import { createUserSessionStore } from "@be-miniapp/shared/stores"

const useUserStore = createUserSessionStore({
  initialLocation: {
    latitude: undefined,
    longitude: undefined,
  },
  removeAccessToken: () => {
    if (!lodashGet(window, "localStorage", null)) return
    localStorage?.removeItem(ACCESS_TOKEN_KEY)
  },
})

export { useUserStore }
